import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/packages/docs-site/src/components/containers/MdxLayout.js";
import { Fragment } from 'react';
import { Playground, PropsTable } from '@versionone/doc-components';
import { Drawer } from './';
import { Button } from '../Button';
import { SpacedGroup } from '../SpacedGroup';
import { TextField } from '../TextField';
import { FocusManager, FocusGroup } from '../FocusManager';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const StateManager = makeShortcode("StateManager");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Drawers are used when you need to augment or switch a user's context. It may be combined with focus groups (see `}<a parentName="p" {...{
        "href": "/components/FocusManager"
      }}>{`FocusManager`}</a>{`), to ensure that the consumer can switch focus to the drawer and then return it once the drawer closes.`}</p>
    <h2>{`Placement`}</h2>
    <Playground __position={0} __code={'{() => {\n    class StateManager extends React.Component {\n      constructor(props, context) {\n        super(props, context)\n        this.state = {\n          right: {\n            open: false,\n            shadow: true,\n            placement: \'right\',\n          },\n          left: {\n            open: false,\n            shadow: true,\n            placement: \'left\',\n          },\n          bottom: {\n            open: false,\n            shadow: true,\n            placement: \'bottom\',\n          },\n          top: {\n            open: false,\n            shadow: true,\n            placement: \'top\',\n          },\n        }\n        this.toggle = this.toggle.bind(this)\n        this.toggleShadow = this.toggleShadow.bind(this)\n        this.handleClose = this.handleClose.bind(this)\n      }\n      toggle(placement) {\n        return () => {\n          this.setState(\n            Object.assign({}, this.state, {\n              [placement]: Object.assign({}, this.state[placement], {\n                open: !this.state[placement].open,\n              }),\n            }),\n          )\n        }\n      }\n      toggleShadow() {\n        this.setState(\n          Object.assign({}, this.state, {\n            right: Object.assign(this.state.right, {\n              shadow: !this.state.right.shadow,\n            }),\n            left: Object.assign(this.state.left, {\n              shadow: !this.state.left.shadow,\n            }),\n            bottom: Object.assign(this.state.bottom, {\n              shadow: !this.state.bottom.shadow,\n            }),\n            top: Object.assign(this.state.top, {\n              shadow: !this.state.top.shadow,\n            }),\n          }),\n        )\n      }\n      handleClose(placement) {\n        return () => {\n          this.setState(\n            Object.assign({}, this.state, {\n              [placement]: Object.assign({}, this.state[placement], {\n                open: false,\n              }),\n            }),\n          )\n        }\n      }\n      render() {\n        const toggleLeft = this.toggle(\'left\')\n        const toggleRight = this.toggle(\'right\')\n        const toggleBottom = this.toggle(\'bottom\')\n        const toggleTop = this.toggle(\'top\')\n        const closeLeft = this.handleClose(\'left\')\n        const closeRight = this.handleClose(\'right\')\n        const closeBottom = this.handleClose(\'bottom\')\n        const closeTop = this.handleClose(\'top\')\n        return (\n          <div>\n            <Button onClick={toggleLeft}>Left\n            <Button onClick={toggleRight}>Right</Button>\n            <Button onClick={toggleBottom}>Bottom</Button>\n            <Button onClick={toggleTop}>Top</Button>\n            <Button onClick={this.toggleShadow}>Toggle Shadow</Button>\n            <Drawer {...this.state.left} handleClickOutside={closeLeft} />\n            <Drawer {...this.state.right} handleClickOutside={closeRight} />\n            <Drawer {...this.state.bottom} handleClickOutside={closeBottom} />\n            <Drawer {...this.state.top} handleClickOutside={closeTop} />\n          </div>\n        )\n      }\n    }\n    return <StateManager />\n  }}\n</Playground>'} __scope={{
      props: this ? this.props : props,
      DefaultLayout,
      Fragment,
      Playground,
      PropsTable,
      Drawer,
      Button,
      SpacedGroup,
      TextField,
      FocusManager,
      FocusGroup
    }} mdxType="Playground">
  {() => {
        class StateManager extends React.Component {
          constructor(props, context) {
            super(props, context);
            this.state = {
              right: {
                open: false,
                shadow: true,
                placement: 'right'
              },
              left: {
                open: false,
                shadow: true,
                placement: 'left'
              },
              bottom: {
                open: false,
                shadow: true,
                placement: 'bottom'
              },
              top: {
                open: false,
                shadow: true,
                placement: 'top'
              }
            };
            this.toggle = this.toggle.bind(this);
            this.toggleShadow = this.toggleShadow.bind(this);
            this.handleClose = this.handleClose.bind(this);
          }

          toggle(placement) {
            return () => {
              this.setState(Object.assign({}, this.state, {
                [placement]: Object.assign({}, this.state[placement], {
                  open: !this.state[placement].open
                })
              }));
            };
          }

          toggleShadow() {
            this.setState(Object.assign({}, this.state, {
              right: Object.assign(this.state.right, {
                shadow: !this.state.right.shadow
              }),
              left: Object.assign(this.state.left, {
                shadow: !this.state.left.shadow
              }),
              bottom: Object.assign(this.state.bottom, {
                shadow: !this.state.bottom.shadow
              }),
              top: Object.assign(this.state.top, {
                shadow: !this.state.top.shadow
              })
            }));
          }

          handleClose(placement) {
            return () => {
              this.setState(Object.assign({}, this.state, {
                [placement]: Object.assign({}, this.state[placement], {
                  open: false
                })
              }));
            };
          }

          render() {
            const toggleLeft = this.toggle('left');
            const toggleRight = this.toggle('right');
            const toggleBottom = this.toggle('bottom');
            const toggleTop = this.toggle('top');
            const closeLeft = this.handleClose('left');
            const closeRight = this.handleClose('right');
            const closeBottom = this.handleClose('bottom');
            const closeTop = this.handleClose('top');
            return <div>
            <Button onClick={toggleLeft} mdxType="Button">Left</Button>
            <Button onClick={toggleRight} mdxType="Button">Right</Button>
            <Button onClick={toggleBottom} mdxType="Button">Bottom</Button>
            <Button onClick={toggleTop} mdxType="Button">Top</Button>
            <Button onClick={this.toggleShadow} mdxType="Button">Toggle Shadow</Button>
            <Drawer {...this.state.left} handleClickOutside={closeLeft} mdxType="Drawer" />
            <Drawer {...this.state.right} handleClickOutside={closeRight} mdxType="Drawer" />
            <Drawer {...this.state.bottom} handleClickOutside={closeBottom} mdxType="Drawer" />
            <Drawer {...this.state.top} handleClickOutside={closeTop} mdxType="Drawer" />
          </div>;
          }

        }

        return <StateManager mdxType="StateManager" />;
      }}
    </Playground>
    <h2>{`Focus`}</h2>
    <p>{`When opening a drawer, the focus is given and scoped to the contents of the drawer. Upon closing the drawer, focus is given back to the element that triggered the drawer to open.`}</p>
    <blockquote>
      <p parentName="blockquote">{`In order to "give back" focus, the consumer of `}<inlineCode parentName="p">{`Drawer`}</inlineCode>{` must establish a `}<inlineCode parentName="p">{`FocusManager.FocusGroup`}</inlineCode>{` (see `}<a parentName="p" {...{
          "href": "/components/FocusManager"
        }}>{`FocusManager`}</a>{`).`}</p>
    </blockquote>
    <Playground __position={1} __code={'{() => {\n    class StateManager extends React.Component {\n      constructor(props, context) {\n        super(props, context)\n        this.state = {\n          open: false,\n        }\n        this.open = this.open.bind(this)\n        this.handleClose = this.handleClose.bind(this)\n      }\n      open() {\n        this.setState(({ open }) => ({\n          open: true,\n        }))\n      }\n      handleClose() {\n        this.setState(\n          ({ open }) => ({\n            open: false,\n          }),\n          this.pop,\n        )\n      }\n      render() {\n        return (\n          <FocusManager>\n            {pop => {\n              this.pop = pop\n              return (\n                <FocusGroup>\n                  {bind => (\n                    <Fragment>\n                      <Button {...bind} onClick={this.open}>\n                        Open Drawer\n                      \n                      <Drawer\n                        {...this.state}\n                        handleClickOutside={this.handleClose}\n                        placement=\"right\"\n                      >\n                        <FocusGroup>\n                          {bind => (\n                            <SpacedGroup direction=\"vertical\">\n                              <TextField {...bind} focused={this.state.open} />\n                              <TextField {...bind} />\n                              <TextField {...bind} />\n                              <TextField {...bind} />\n                              <Button onClick={this.handleClose}>Close</Button>\n                            </SpacedGroup>\n                          )}\n                        </FocusGroup>\n                      </Drawer>\n                    </Fragment>\n                  )}\n                </FocusGroup>\n              )\n            }}\n          </FocusManager>\n        )\n      }\n    }\n    return <StateManager />\n  }}\n</Playground>'} __scope={{
      props: this ? this.props : props,
      DefaultLayout,
      Fragment,
      Playground,
      PropsTable,
      Drawer,
      Button,
      SpacedGroup,
      TextField,
      FocusManager,
      FocusGroup
    }} mdxType="Playground">
  {() => {
        class StateManager extends React.Component {
          constructor(props, context) {
            super(props, context);
            this.state = {
              open: false
            };
            this.open = this.open.bind(this);
            this.handleClose = this.handleClose.bind(this);
          }

          open() {
            this.setState(({
              open
            }) => ({
              open: true
            }));
          }

          handleClose() {
            this.setState(({
              open
            }) => ({
              open: false
            }), this.pop);
          }

          render() {
            return <FocusManager mdxType="FocusManager">
            {pop => {
                this.pop = pop;
                return <FocusGroup mdxType="FocusGroup">
                  {bind => <Fragment mdxType="Fragment">
                      <Button {...bind} onClick={this.open} mdxType="Button">
                        Open Drawer
                      </Button>
                      <Drawer {...this.state} handleClickOutside={this.handleClose} placement="right" mdxType="Drawer">
                        <FocusGroup mdxType="FocusGroup">
                          {bind => <SpacedGroup direction="vertical" mdxType="SpacedGroup">
                              <TextField {...bind} focused={this.state.open} mdxType="TextField" />
                              <TextField {...bind} mdxType="TextField" />
                              <TextField {...bind} mdxType="TextField" />
                              <TextField {...bind} mdxType="TextField" />
                              <Button onClick={this.handleClose} mdxType="Button">Close</Button>
                            </SpacedGroup>}
                        </FocusGroup>
                      </Drawer>
                    </Fragment>}
                </FocusGroup>;
              }}
          </FocusManager>;
          }

        }

        return <StateManager mdxType="StateManager" />;
      }}
    </Playground>
    <h2>{`API`}</h2>
    <PropsTable of={Drawer} mdxType="PropsTable" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      